import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  MEDIUM_DEVICE_MQ,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const cardHeroClassName = css({
  paddingTop: Spacing['3XL'],
});

export const innerClassName = css({
  background: Colors.White,
  borderRadius: 4,
  boxShadow: `0px 4px 20px 0px rgb(0, 0, 0, 0.1)`,
  padding: `${Spacing['2XL']}px ${Spacing.MD}px`,
  [MEDIUM_DEVICE_MQ]: {
    padding: `${Spacing.XL + 4}px ${Spacing['2XL']}px`,
  },
});

export const headerClassName = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  [MEDIUM_DEVICE_MQ]: {
    flexDirection: 'row',
  },
});

export const headerTextClassName = css({
  textAlign: 'center',
  [MEDIUM_DEVICE_MQ]: {
    textAlign: 'left',
  },
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: 24,
  fontWeight: FontWeight.BOLD,
  [SMALL_DEVICE_MQ]: {
    fontSize: 26,
  },
});

export const subheadingClassName = css({
  color: Colors.Secondary,
  fontSize: 20,
  fontWeight: FontWeight.BOLD,
  marginBottom: Spacing.SM,
  [MEDIUM_DEVICE_MQ]: {
    fontWeight: FontWeight.SEMI_BOLD,
    marginBottom: Spacing['2XS'],
  },
});

export const bodyClassName = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  marginTop: Spacing.XL,
  [MEDIUM_DEVICE_MQ]: {
    justifyContent: 'flex-end',
    marginTop: 0,
  },
});

export const buttonClassName = css({
  background: 'var(--card-color-accent)',
  border: 'none',
  color: `var(--card-color-text, ${Colors.White})`,
  minHeight: 54,
  padding: `${Spacing.SM}px ${Spacing.LG}px`,
  transition: '600ms',
  '&:hover': {
    transform: 'scale(1.03)',
  },
});

export const buttonIconClassName = css({
  position: 'relative',
  top: '-0.5px',
  '& > svg': {
    height: 16,
    width: 16,
  },
});

export const buttonTextClassName = css({
  fontFamily: `'Nunito', sans-serif`,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.EXTRA_BOLD,
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.BOLD,
  },
});

export const footerClassName = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.LG,
  justifyContent: 'center',
  marginTop: Spacing.XL,
  [SMALL_DEVICE_MQ]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginTop: 18,
    marginBottom: `-${Spacing.XS}px`,
  },
});

export const footerRightClassName = css({
  [SMALL_DEVICE_MQ]: {
    marginLeft: 'auto',
  },
});

export const footerTextClassName = css({
  alignItems: 'center',
  color: Colors.Secondary,
  display: 'flex',
  fontSize: FontSize.REGULAR,
  gap: Spacing['1XS'],
});

export const footerTextLabelClassName = css({
  fontWeight: FontWeight.MEDIUM,
});

export const italicTextClassName = css({
  fontStyle: 'italic',
});

export const footerTextValueClassName = css({
  fontWeight: FontWeight.BOLD,
});

export const fontSmallClassName = css({
  fontSize: FontSize.REGULAR,
  [SMALL_DEVICE_MQ]: {
    fontSize: FontSize.COMPACT,
  },
});
